// extracted by mini-css-extract-plugin
export default {"root":"rls4W5OOMN","documentNameContainer":"tidrECwEdP"};